import arrow from './images/Arrow_Quem_Somos.png'
import angular from './images/angularnew.png'
import nodejs from './images/node-js.svg'
import amazon from './images/awslogo.png'
import googlecloud from './images/googlecloud.png'
import microsoftazure from './images/azure.png'
import python from './images/python.png'
import java from './images/java.png'
import react from './images/reactnew.png'
import devops from './images/devops.svg'
import infrastructure from './images/infrastructure.svg'
import outsourcing from './images/outsourcing.svg'
import softwareengineering from './images/softwareengineering.svg'
import se from './images/se.svg'
import ie from './images/ie.svg'
import outsource from './images/outsource.svg'
import pfsense from './images/pfsense.png'
import cisco from './images/cisco.svg'
import fortinet from './images/fortinet-logo.svg'
import kaspersky from './images/kaspersky.png'
import gitlab from './images/gitlablogo.png'


const images = { arrow, angular, nodejs, amazon, googlecloud, microsoftazure, 
    python, java, react, devops, infrastructure, outsourcing, softwareengineering, 
    se, ie, outsource, pfsense, cisco, fortinet, gitlab, kaspersky }

export default images